module.exports = __webpack_public_path__ + "static/media/box.e9830132.bmp";